// extracted by mini-css-extract-plugin
export default {"criterionDescription":"_2ZVV2","criterionDetails":"_sbqtA","criterionWrapper":"_i6EcR","scoreInput":"_3BJmk","validationMessage":"_1X_9B"};